const paths = {
  settings: 'settings',
  home: '',
  queues: '/queues',
  callCenterMonitoring: '/monitoring/call-center',
  queuesMonitoring: '/monitoring/queues',
  outboundMonitoring: '/monitoring/outbound',
  voiceAgentDashboard: '/reports/voice-agent-dashboard',
  voiceIntelligenceCalls: '/voice-intelligence/calls',
  voiceIntelligenceInsights: '/voice-intelligence/insights',
} as const;

export const settingsPaths = {
  userManagement: 'usermanagement',
  workflows: 'workflows',
  callContinuity: 'callContinuity',
  queueManagement: 'queues',
  presetDaysTimes: 'presetdaystimes',
  virtualAgents: 'virtualagents',
  manageAccounts: 'manageaccounts',
  globalRecording: 'recording/global',
  transfersRecording: 'recording/transfers',
  individualRecording: 'recording/individuals',
  queueRecording: 'recording/queues',
  recordingExclusionList: `recording/exclusions`,
  fmCallAnalysis: 'featureManagement/callAnalysis',
  dataIntegration: 'featureManagement/dataIntegration',
  inboxTaskCards: 'featureManagement/inboxtaskcards',
  liveServicesPhoneMapping: 'featureManagement/liveServices',
  outboundNumbers: 'featureManagement/outboundNumbers',
} as const;

export default {
  ...paths,
  ...(Object.fromEntries(
    Object.entries(settingsPaths).map(([key, value]) => [
      key,
      `${paths.settings}/${value}`,
    ]),
  ) as Record<keyof typeof settingsPaths, string>),
} as const;
